<template>
  <button
    :class="
      `ml-4 box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black`
    "
    type="submit"
    v-bind="$attrs"
  >
    <div class="flex flex-row items-center justify-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-1"
      >
        <circle cx="11" cy="11" r="10.5" stroke="#B8A000" fill="#B8A000" />
      </svg>
      <div class="flex flex-row items-baseline">
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          入力
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`">を</span>
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          確認
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`">
          する
        </span>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'AppBudgetShowPreviewBtn',

  props: {
    color: String,
  },
}
</script>

<style lang="scss" scoped>
button {
  border-radius: 20px;
  width: 512px;
  &:disabled {
    div {
      svg {
        circle {
          fill: #b8a000;
        }
      }
    }
  }
}
</style>
